import { SetAlert } from "@apex/component-library/components/Alert/types";
import { Toast } from "@apex/component-library/components/Toast/types";
import { AxiosError } from "axios";

import {
  DEFAULT_ERROR_TOAST,
  INTERNAL_SERVER_ERROR_ALERT_CONFIG,
  UNAUTHORIZED_ERROR_TOAST,
} from "../../utils/constants";

export default function onMutateError(
  setAlert: SetAlert,
  toast: (toast: Toast) => void
) {
  return (error: unknown) => {
    const err = error as AxiosError<{ errorDescription: string }>;
    const description =
      (err.response && err.response.data.errorDescription) || "";
    const status = err.response?.status || err.request.status;
    switch (status) {
      case 500:
        setAlert(INTERNAL_SERVER_ERROR_ALERT_CONFIG);
        break;
      case 403:
        toast({
          ...UNAUTHORIZED_ERROR_TOAST,
          description:
            "Sorry, the request cannot be completed. Additional permissions are required.",
        });
        break;
      default:
        toast({
          ...DEFAULT_ERROR_TOAST,
          description,
        });
        break;
    }
  };
}
